import { upperFirst } from 'lodash';
import { SsoProvider, SsoRefreshErrorPayload } from './types';

export const SSO_ERROR_PAGE_PATH = '/single-sign-on-error';

export function friendlySsoProvider(ssoProvider: SsoProvider) {
  switch (ssoProvider) {
    case 'microsoft':
    case 'google':
      return upperFirst(ssoProvider);
  }
}

// TODO: Use joi or zod for the validation if we want to be really really sure that
// there are no unexpected values present.
export function isSsoRefreshErrorPayload(payload: unknown): payload is SsoRefreshErrorPayload {
  const castPayload = payload as Partial<SsoRefreshErrorPayload> | undefined;
  if (castPayload?.shouldRequestNewSso && !!castPayload.ssoProvider) return true;
  return false;
}
